// extracted by mini-css-extract-plugin
export default {"title":"LoadingAudiences_title__FonyV","box":"LoadingAudiences_box__f85Rs","total":"LoadingAudiences_total__aDPZM"};